import { Component, OnInit, OnDestroy, inject, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { InputFieldComponent } from '../../../../../../../shared/components/input-field/input-field.component';
import { DatepickerComponent } from '../../../../../../../shared/components/datepicker/datepicker.component';
import { SelectComponent } from '../../../../../../../shared/components/select/select.component';
import { Subject } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDivider } from '@angular/material/divider';
import { LearningPlanBuilderCourseSelectionComponent } from '../../../learning-plan-builder-course-selection/learning-plan-builder-course-selection.component';
import { LearningPlanBuilderDataService } from '../../../../services/learning-plan-builder-data.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-learning-plan-setup-configuration',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    InputFieldComponent,
    DatepickerComponent,
    SelectComponent,
    MatIcon,
    MatTooltip,
    MatDivider,
    LearningPlanBuilderCourseSelectionComponent,
  ],
  templateUrl: './learning-plan-setup-configuration.component.html',
})
export class LearningPlanSetupConfigurationComponent
  implements OnInit, OnDestroy
{
  @Input() isCustomTraining = false;
  @Input() isPrecuratedTraining = false;

  protected readonly dataService = inject(LearningPlanBuilderDataService);

  private readonly destroy$: Subject<void> = new Subject();

  ngOnInit(): void {
    document.getElementById('trainingName')?.focus();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get topicAreasWithDisabled() {
    const selectedValue =
      this.dataService.formGroupSettings.controls.topicAreaId.value;

    return this.dataService.topicAreas.map((option) => ({
      ...option,
      disabled: this.hasCoursesSelected && option.value !== selectedValue,
    }));
  }

  get hasCoursesSelected(): boolean {
    const phases = this.dataService.getPhasesArray();
    return phases.controls.some(
      (phase) => phase.controls.course.value !== null,
    );
  }
}
